<template>
  <div class="min-h-screen bg-base-100">
    <div class="container mx-auto px-4 py-12">
      <div class="max-w-4xl mx-auto">
        <h1 class="text-4xl font-bold text-base-content mb-8 text-center">
          Sobre Soleando
        </h1>
        <div class="prose prose-lg max-w-none">
          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              ¿Quiénes somos?
            </h2>
            <p class="text-base-content/80 mb-4">
              Soleando es una plataforma dedicada a ofrecer experiencias de
              viaje únicas y auténticas, conectando a los viajeros con destinos
              extraordinarios y culturas fascinantes. Nuestro objetivo es
              inspirar y facilitar aventuras inolvidables, siempre priorizando
              la sostenibilidad y el respeto por las comunidades locales.
            </p>
          </section>
          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              Nuestro equipo
            </h2>
            <p class="text-base-content/80 mb-4">
              Nuestro equipo está formado por apasionados exploradores y
              expertos en turismo, comprometidos con brindar un servicio
              personalizado y de alta calidad. Creemos en el poder transformador
              de los viajes y trabajamos para que cada aventura sea
              significativa y enriquecedora.
            </p>
          </section>
          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              Nuestra filosofía
            </h2>
            <p class="text-base-content/80 mb-4">
              Apostamos por un turismo responsable, sostenible y respetuoso con
              las comunidades locales y el entorno. Cada viaje es una
              oportunidad para aprender, compartir y crecer.
            </p>
          </section>
          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              ¿Por qué elegir Soleando?
            </h2>
            <ul class="list-disc pl-6 text-base-content/80 mb-4">
              <li>Experiencias auténticas y personalizadas</li>
              <li>Compromiso con la sostenibilidad</li>
              <li>Atención cercana y profesional</li>
              <li>Respeto por las culturas y el medio ambiente</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: "default",
});

useSeoMeta({
  title: "Sobre Soleando",
  description:
    "Conoce más sobre Soleando, nuestra misión, equipo y filosofía de viaje responsable.",
});
</script>

<style scoped></style>
